// actions.js
import {
  FETCH_DASHBOARD_REQUEST,
  FETCH_DASHBOARD_SUCCESS,
  FETCH_DASHBOARD_FAILURE,
  CLEAR_DASHBOARD_ERRORS,
  CLEAR_DASHBOARD_SUCCESS,

} from './actionTypes';

export const fetchDashboardRequest = (id) => ({
  type: FETCH_DASHBOARD_REQUEST,
  payload: id
});

export const fetchDashboardSuccess = (agency) => ({
  type: FETCH_DASHBOARD_SUCCESS,
  payload: agency,
});

export const fetchDashboardFailure = (error) => ({
  type: FETCH_DASHBOARD_FAILURE,
  payload: error,
});

export const clearDashboardErrors = () => ({
  type: CLEAR_DASHBOARD_ERRORS,
});

export const clearDashboardSuccess = () => ({
  type: CLEAR_DASHBOARD_SUCCESS,
});